let scanStartTime: number | null = null;

export function trackStart(video: HTMLVideoElement): void {
  scanStartTime = Date.now();
  try {
    if (typeof gtag === 'function') {
      gtag('event', 'scanner_start', {
        videoResolution: `${video.videoWidth}x${video.videoHeight}`
      });
    }
  } catch {
    /* ignore */
  }
}

export function trackStop(): void {
  const duration = scanStartTime ? Date.now() - scanStartTime : 0;
  scanStartTime = null;
  try {
    if (typeof gtag === 'function') {
      gtag('event', 'scanner_stop', {
        durationMs: duration
      });
    }
  } catch {
    /* ignore */
  }
}
